import RejectEnrollmentPage from './RejectEnrollmentPage'
export default RejectEnrollmentPage
